import Actions from 'actions';

const initialState = Object.freeze({});

function update(state = initialState, action) {
  switch (action.type) {
    case Actions.UPDATE_USER_REQUEST:
      return initialState;
    case Actions.UPDATE_USER_SUCCESS:
      return {
        ...initialState,
        data: action.data,
      };
    case Actions.UPDATE_USER_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default update;
